<template>
  <v-app id="inspire">
    <v-main style="background-color: #24292d; font-family: 'Poppins', sans-serif !important;">
      <cabecerabaja class=" hidden-md-only hidden-lg-only hidden-xl-only" />

      <v-container fluid fill-height align-start>
        <v-row  >
          <v-col md="12" lg="12" cols="12">
            <v-alert
                :value="alertborrador"
                color="red"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Sus datos se borraron con éxito.
            </v-alert>
            <v-alert
                :value="alertnuevo"
                color="primary"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Sus datos se agregaron con éxito.
            </v-alert>
            <v-alert
                :value="alerteditar"
                color="green"
                dark
                dismissible
                border="top"
                transition="scale-transition"
            >
              Sus datos se editaron con éxito.
            </v-alert>
            <v-card color="#393E46">
              <v-tabs
                  v-model="tab"
                  centered
                  dark
                  icons-and-text
                  background-color="#6D9886"
                  color="#393E46"
              >
                <v-tabs-slider></v-tabs-slider>
                <v-tab href="#tab-datos">
                  Datos
                  <v-icon>fas fa-phone</v-icon>
                </v-tab>
                <v-tab href="#tab-reservas">
                  Atención
                  <v-icon>fas fa-file-signature</v-icon>
                </v-tab>
                <v-tab href="#tab-ubicacion">
                  Ubicación
                  <v-icon>fas fa-map-marked</v-icon>
                </v-tab>
                <v-tab href="#tab-logos">
                  Logos
                  <v-icon>fas fa-images</v-icon>
                </v-tab>
                <v-tab href="#tab-disenio">
                  Diseño
                  <v-icon>fas fa-palette</v-icon>
                </v-tab>
                <v-tab-item  key="tab-datos" value="tab-datos">
                  <v-card flat color="#393E46">
                    <v-card-title>
                      <span class="headline">Datos</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field prepend-icon="fas fa-briefcase" :counter="200" required v-model="editedItem.negocio" label="Nombre"></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field prepend-icon="fas fa-tag" :counter="50" required readonly v-model="editedItem.tag" label="Tag" ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field prepend-icon="fab fa-internet-explorer" :counter="100" v-model="editedItem.website" label="Página Web" ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field prepend-icon="fab fa-instagram" :counter="100" v-model="editedItem.instagram" label="Instagram" ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field  prepend-icon="fab fa-facebook" :counter="100" v-model="editedItem.facebook" label="Facebook" ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-btn  dark large color="primary" @click="save" >Grabar</v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-reservas">
                  <v-card flat color="#393E46">
                    <v-card-title>
                      <span class="headline">Datos sobre la Atención</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field  prepend-icon="fas fa-at" :counter="100" type="email" v-model="editedItem.mailreserva" label="Mail Reservas" ></v-text-field>
                      </v-col>
                          </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
<h2>Dias de Atención</h2>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="3" lg="2">
                            <v-switch label="Lunes" v-model="editedItem.lunes" @change="save"></v-switch>
                          </v-col><v-col cols="3" lg="2">
                          <v-switch label="Martes" v-model="editedItem.martes" @change="save"></v-switch>
                        </v-col><v-col cols="3" lg="2">
                          <v-switch label="Miercoles" v-model="editedItem.miercoles" @change="save"></v-switch>
                        </v-col><v-col cols="3" lg="2">
                          <v-switch label="Jueves" v-model="editedItem.jueves"  @change="save"></v-switch>
                        </v-col><v-col cols="3" lg="2">
                          <v-switch label="Viernes" v-model="editedItem.viernes" @change="save"></v-switch>
                        </v-col><v-col cols="3" lg="2">
                          <v-switch label="Sabado" v-model="editedItem.sabado"  @change="save"></v-switch>
                        </v-col><v-col cols="3" lg="2">
                          <v-switch label="Domingo" v-model="editedItem.domingo"  @change="save"></v-switch>
                        </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                           <h2> Creación de Fiestas Automático</h2>
                          </v-col>
                          </v-row><v-row>
                          <v-col>
                            <v-switch v-model="editedItem.automatico" label="Automatico"  @change="save"></v-switch>
                          </v-col>
                        </v-row>
                        <v-row>

                          <v-col cols="6" sm="6" md="6">
                            <p>Hora Apertura</p>
                            <v-time-picker color="#393E46" prepend-icon="fas fa-clock"   v-model="editedItem.horaApertura" label="Hora Apertura" ></v-time-picker>
                          </v-col>
                          <v-col cols="6" sm="6" md="6">
                            <p>Hora Cierre</p>
                            <v-time-picker  color="#393E46" prepend-icon="fas fa-clock"  v-model="editedItem.horaCierre" label="Hora Cierre" ></v-time-picker>
                          </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-btn  dark large color="primary" @click="save" >Grabar</v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-ubicacion">
                  <v-card flat color="#393E46">
                    <v-card-title>
                      <span class="headline">Ubicación</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col  cols="6" sm="6" md="6">
                            <v-autocomplete  v-model="editedItem.ciudad.provincia.pais" :items="paises"  item-text="pais" persistent-hint
                                             return-object
                                             @change="cambiopais"
                                             single-line label="Escoger Pais"></v-autocomplete>
                          </v-col>
                          <v-col  cols="6" sm="6" md="6">
                            <v-autocomplete  v-model="editedItem.ciudad.provincia" :items="provincias" item-text="provincia" persistent-hint
                                              return-object
                                             @change="cambioprovincia"
                                             single-line label="Escoger Provincia"></v-autocomplete>
                          </v-col>
                          <v-col  cols="6" sm="6" md="6">
                            <v-autocomplete  v-model="editedItem.ciudad" :items="ciudades"  item-text="ciudad" persistent-hint
                                             return-object
                                             single-line label="Escoger Ciudad"></v-autocomplete>
                          </v-col>

                      <v-col cols="6" sm="6" md="6">
                        <v-text-field  prepend-icon="fas fa-map-marker" v-model="editedItem.latitud" label="Latitud" @change="cambioubic" readonly ></v-text-field>

                      </v-col>
                      <v-col cols="6" sm="6" md="6">
                        <v-text-field  prepend-icon="fas fa-map-marker" v-model="editedItem.longitud" label="Longintud" @change="cambioubic" readonly ></v-text-field>

                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <gmaps-map @mounted="ready" :options="options"
                                   style='width:100%;  height: 400px;'>
                          <gmaps-marker :position="options.position" :options="optionsMarker"  @dragend="updateCoordinates"  />
                        </gmaps-map>

                      </v-col>
                          <v-col cols="12" sm="12" md="12">
                            <v-btn  dark large color="primary" @click="save" >Grabar</v-btn>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-logos">
                  <v-card flat color="#393E46">
                    <v-card-title>
                      <span class="headline">Logos</span>
                    </v-card-title>
                    <v-card-text>
<v-row>
  <v-col cols="12" lg="4">
    <v-img width="90" :src="negocio.logo90"></v-img>
  </v-col>
  <v-col cols="12" lg="8">
    <v-file-input
        label="Subir Archivo 90 x90 "
        accept="image/*"
        filled
        chips
        v-model="imagen90"
        @change="onFileChange90"
        prepend-icon="mdi-camera"
    ></v-file-input>
  </v-col>
</v-row>
                      <v-row>
                        <v-col cols="12" lg="4">
                          <v-img width="180" :src="negocio.logo180"></v-img>
                        </v-col>
                        <v-col cols="12" lg="8">
                          <v-file-input
                              label="Subir Archivo 180 x 180 "
                              accept="image/*"
                              filled
                              chips
                              v-model="imagen180"
                              @change="onFileChange180"
                              prepend-icon="mdi-camera"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" lg="4">
                          <v-img width="270" :src="negocio.logo270"></v-img>
                        </v-col>
                        <v-col cols="12" lg="8">
                          <v-file-input
                              label="Subir Archivo 270 x 270 "
                              accept="image/*"
                              filled
                              chips
                              v-model="imagen270"
                              @change="onFileChange270"
                              prepend-icon="mdi-camera"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
                <v-tab-item value="tab-disenio">
                  <v-card flat color="#393E46">
                    <v-card-title>
                      <span class="headline">Diseño</span>
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col>
                          <h2>Canjeo de Qrs solo para invitados</h2>
                        </v-col>
                      </v-row><v-row>
                      <v-col>
                        <v-switch v-model="editedItem.soloInvitacion" label="Solo Invitados"  @change="save"></v-switch>
                      </v-col>
                    </v-row>
                      <v-row>
                        <v-col cols="12" lg="4">
                          <v-img width="270" :src="negocio.qrBg"></v-img>
                        </v-col>
                        <v-col cols="12" lg="8">
                          <v-file-input
                              label="Subir Background 1800 x 1200, menos de 1 mb"
                              accept="image/*"
                              filled
                              chips
                              v-model="imagenQrBg"
                              @change="onFileChange270"
                              prepend-icon="mdi-camera"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" lg="4">
                          <v-img width="270" :src="negocio.qrBg"></v-img>
                        </v-col>
                        <v-col cols="12" lg="8">
                          <v-file-input
                              label="Subir Background Mobile 600 x 1200, menos de 1 mb"
                              accept="image/*"
                              filled
                              chips
                              v-model="imagenQrBg"
                              @change="onFileChange270"
                              prepend-icon="mdi-camera"
                          ></v-file-input>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs>


            </v-card>
          </v-col>

        </v-row>
        <leftmenu :abreviado="abreviado" />
        <v-overlay :value="overlay">
          <v-img
              src="@/assets/loadtunay.gif"

          />
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex";
import leftmenu from '../../general/leftmenu';
import axios from "axios";
import firebase from 'firebase/compat/app';
import Cabecerabaja from "@/components/general/cabecerabaja";
import { gmaps, gmapsMap, gmapsMarker } from 'x5-gmaps';

export default {
  title: 'Configuración | Tunay Mi acceso de bolsillo',

  components: {
    Cabecerabaja,
    leftmenu,
    gmapsMap,
    gmapsMarker
  },
  data: () => ({
    drawer: null,
    tab: null,
    center: { lat: 45.508, lng: -73.587 },
    idnegocio: 0,
    paises:[],
    provincias:[],
    overlay: false,
token:'',
    ciudades:[],
    imagen90:'',
    imagen180:'',
    imagen270:'',
    imagenQrBg:'',
    abreviado:'NN',
    imagenQrBgMob:'',
    distritos:[],
    alertborrador: false,
    alertnuevo: false,
    alerteditar: false,
    options:{
      position:{ lat: -12.0792903, lng: -77.004896 },
      center:{ lat: -12.0792903, lng: -77.004896 },
      zoom: 18
    },
    optionsMarker:{
      draggable:true
    },
    negocio: {
      activo: true,
      cantMinutos: 0,
      ciudad: {id: 129, ciudadNombre: "Lima"},
      cliente: {id: 4, clienteNombre: "Grupo Bros", logo: "", razonSocial: "", ruc: ""},
      direccion: "",
      facebook: "",
      horaApertura: "00:00:00",
      horaCierre: "00:00:00",
      icono: "",
      id: 23,
      impuesto: "",
      instagram: "",
      latitud: -3.7474129,
      logo: "",
      longitud: -73.2455166,
      mailreserva: "",
      moneda: {id: 1, moneda: "Soles", shortmoneda: "S/."},
      negocioNombre: "Noa",
      periocidad: {id: 8, periocidad: "anual", cantDias: 364},
      tag: "noa",
      tipoNegocio: {id: 2, tipoNegocio: "Discoteca"},
      website: ""
    },
    editedItem:{
      activo: true,
      cantMinutos: 0,
      ciudad: {id: 129, ciudadNombre: "Lima"},
      cliente: {id: 4, clienteNombre: "Grupo Bros", logo: "", razonSocial: "", ruc: ""},
      direccion: "",
      facebook: "",
      horaApertura: "00:00:00",
      horaCierre: "00:00:00",
      icono: "",
      id: 23,
      impuesto: "",
      instagram: "",
      latitud: -3.7474129,
      logo: "",
      longitud: -73.2455166,
      mailreserva: "",
      moneda: {id: 1, moneda: "Soles", shortmoneda: "S/."},
      negocioNombre: "Noa",
      periocidad: {id: 8, periocidad: "anual", cantDias: 364},
      tag: "noa",
      tipoNegocio: {id: 2, tipoNegocio: "Discoteca"},
      website: "",
      lunes:false,
      martes:false,
      miercoles:false,
      jueves:false,
      viernes:false,
      sabado:false,
      domingo:false,
      automatico:false
    }
  }),
  mounted (){
    this.idnegocio =  this.$route.params.idnegocio;

    this.negocio = this.negocios.find(x=>x.tag ===this.idnegocio)
    if (this.usuario.id === undefined){
      this.overlay = true
      firebase
          .auth()
          .onAuthStateChanged(user => {
            if(user){
              this.overlay = false
              this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
              this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

              this.damenegocio()
            }else{
              this.overlay = false
              this.$router.push({ path: '/' });
            }
          })


    }else{
      this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
      this.abreviado = this.usuario.nombre + " " + this.usuario.apellidoPaterno

      this.damenegocio()
    }
  },
  watch:{
    "$route.params.idnegocio"(value) {
      console.log(value);
      this.idnegocio =  this.$route.params.idnegocio
      this.negocio = this.negocios.find(x=>x.tag === this.idnegocio)
      if (this.usuario.id === undefined){
        this.$router.push({ path: '/' });

      }else{
        this.token  = firebase.auth().currentUser.auth.currentUser.accessToken;
        this.damenegocio()
      }
    }
  },
  methods:{
    updateCoordinates(location) {
      this.options.center = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
      this.options.position = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
      console.log(location)
      this.editedItem.longitud =  location.latLng.lng()
      this.editedItem.latitud = location.latLng.lat()
    },
    cambiopais(){
      this.dameprovincias()
    },
    cambioprovincia(){

      this.dameciudades()
    },
    onFileChange90(e) {
      this.negocio.logo90= URL.createObjectURL(this.imagen90)
      var bodyFormData = new FormData();
      bodyFormData.append("file",this.imagen90);
      let url = "negocios/logo/" + this.negocio.id + "/90"
      this.overlay = true
      axios
          .post(url,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.dialoguploadimage = false;
            this.overlay = false
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
      console.log(e)
    },
    ready(map) {
      this.map = map
      gmaps().then((maps) => {
        this.places = new maps.places.PlacesService(map)
        this.autocomplete = new maps.places.Autocomplete(this.$refs.autocomplete)
        this.autocomplete.addListener('place_changed', this.update)
      })
    },
    update() {
      const place = this.autocomplete.getPlace()
      if (place.geometry) {
        this.map.panTo(place.geometry.location)
        this.markerPos = place.geometry.location
        this.options.position = place.geometry.location
        this.options.center = place.geometry.location
        this.editedItem.latitud = place.geometry.viewport.eb.hi
        this.editedItem.longitud = place.geometry.viewport.Ha.hi
      //  let disct = place.address_components.find(x=>x.types[0]==="locality")

      }
    },
    onFileChange180(e) {
      this.negocio.logo180= URL.createObjectURL(this.imagen180)
      var bodyFormData = new FormData();
      bodyFormData.append("file",this.imagen180);
      let url = "negocios/logo/" + this.negocio.id + "/180"
      this.overlay = true
      axios
          .post(url,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.dialoguploadimage = false;
            this.overlay = false
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
          });
      console.log(e)
    },
    onFileChange270(e) {
      this.negocio.logo270= URL.createObjectURL(this.imagen270)

      var bodyFormData = new FormData();
      bodyFormData.append("file",this.imagen270);
      let url = "negocios/logo/" + this.negocio.id + "/270"
      this.overlay = true
      axios
          .post(url,bodyFormData,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            console.assert(true,response);
            this.dialoguploadimage = false;
            this.overlay = false
          })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
            this.overlay = false;
          });
      console.log(e)
    },
    damepaises(){
      this.overlay = true;
      axios
          .get('paises',{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.paises = response.data;
            this.dameprovincias()
            this.overlay = false;

          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;

          });
    },
    dameprovincias(){
      this.overlay = true;
      axios
          .get('provincias/pais/'+this.editedItem.ciudad.provincia.pais.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.provincias = response.data;
            this.dameciudades()
            this.overlay = false;

          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;

          });
    },
    dameciudades(){
      this.overlay = true;
      axios
          .get('ciudades/provincia/'+this.editedItem.ciudad.provincia.id,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.ciudades = response.data;
            this.overlay = false;

          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;

          });
    },
    cambioubic(){
      this.options.center = {
        lat: this.editedItem.latitud,
        lng: this.editedItem.longitud,
      };
      this.options.position = {
        lat: this.editedItem.latitud,
        lng: this.editedItem.longitud,
      };
    },
    save(){
      var bodyFormData2 = new FormData();
      this.overlay = true;
      bodyFormData2.append("data",JSON.stringify(this.editedItem));
      axios
          .post('negocios/actualiza',bodyFormData2,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          }).then(response => {
        console.log(response);
        this.alerteditar = true;
        this.overlay = false;

      })
          .catch(error => {
            this.error = "Hubo un error";
            console.log(error);
            this.overlay = false;

          });
    },
    damenegocio(){
      this.overlay = true;

      axios
          .get('negocios/tag/'+this.idnegocio,{
            headers: {
              'Authorization': `Bearer ${this.token}`,
            }
          })
          .then(response => {
            this.editedItem = response.data;
            this.options.center = { lat: this.editedItem.latitud, lng: this.editedItem.longitud };
            this.options.position = { lat: this.editedItem.latitud, lng: this.editedItem.longitud };

            this.damepaises()
            this.overlay = false;

          })
          .catch((error)  => {
            console.log(error);
            this.overlay = false;

          });
    }
  },
  computed:{
    ...mapGetters({
      user: "user",
      usuario: "usuario",
      negocios: "negocios",
      cliente: "cliente"
    })
  }
}
</script>
